import { Link, useLocation, useNavigate } from "react-router-dom";
import { KeyRound, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Header() {
  const { count, setOpen } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const goManifesto = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" }), 350);
    } else {
      document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian/75 backdrop-blur-xl">
      <div className="flex items-center justify-between px-6 py-4 sm:px-12 lg:px-20">
        <Link to="/" data-testid="nav-logo" className="font-display text-xl font-semibold tracking-[0.2em] text-bone">
          ATELIER <span className="text-vermilion">NORTE</span>
        </Link>
        <nav className="hidden items-center gap-10 md:flex">
          <Link to="/shop" data-testid="nav-link-shop" className="font-mono text-xs uppercase tracking-[0.25em] text-smoke transition-colors hover:text-bone">
            Catalog
          </Link>
          <a href="/#manifesto" onClick={goManifesto} data-testid="nav-link-manifesto" className="font-mono text-xs uppercase tracking-[0.25em] text-smoke transition-colors hover:text-bone">
            Manifesto
          </a>
          <Link to="/track" data-testid="nav-link-tracking" className="font-mono text-xs uppercase tracking-[0.25em] text-smoke transition-colors hover:text-bone">
            Tracking
          </Link>
          <Link to="/contact" data-testid="nav-link-contact" className="font-mono text-xs uppercase tracking-[0.25em] text-smoke transition-colors hover:text-bone">
            Contact
          </Link>
        </nav>
        <div className="flex items-center gap-5">
          <Link to="/admin/login" data-testid="nav-admin-trigger" aria-label="Atelier office" className="text-faint transition-colors hover:text-brass">
            <KeyRound size={18} strokeWidth={1.5} />
          </Link>
          <button
            onClick={() => setOpen(true)}
            data-testid="nav-cart-trigger"
            className="relative text-bone transition-colors hover:text-vermilion"
            aria-label="Open cart"
          >
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-vermilion font-mono text-[10px] text-obsidian">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
